module.exports = __webpack_public_path__ + "img/plusEdicion.1c58b93a.svg";